import {
  DISPLAY_DETAIL_READ_ERROR,
  isDisplayDetailReadResponse,
  type DisplayDetailRead,
} from '@/data/contracts/displayDetailRead';
import { supabase } from '@/integrations/supabase/client';

async function readDetail(url: string, headers: Record<string, string>): Promise<DisplayDetailRead | null> {
  const response = await fetch(url, { headers });

  let payload: unknown;
  try {
    payload = await response.json();
  } catch {
    throw new Error(DISPLAY_DETAIL_READ_ERROR);
  }

  if (!response.ok || !isDisplayDetailReadResponse(payload)) {
    throw new Error(DISPLAY_DETAIL_READ_ERROR);
  }

  return payload.display;
}

async function accessToken(): Promise<string | null> {
  try {
    const { data } = await supabase.auth.getSession();
    return data.session?.access_token ?? null;
  } catch {
    return null;
  }
}

export async function fetchDisplayDetail(reference: number | string): Promise<DisplayDetailRead | null> {
  const url = `/api/displays/${encodeURIComponent(String(reference).trim())}`;
  const publicRead = await readDetail(url, { Accept: 'application/json' });
  if (publicRead) return publicRead;

  // Not found publicly. A signed-in owner or admin can still load their own
  // hidden display. This second call carries the token and a distinct URL so
  // it never shares a CDN entry with the cached public "not found".
  const token = await accessToken();
  if (!token) return null;
  return readDetail(`${url}?viewer=1`, { Accept: 'application/json', Authorization: `Bearer ${token}` });
}
